module.exports = __webpack_public_path__ + "media/standardized_tests/photo-0c84fed9.jpg";